module.exports = __webpack_public_path__ + "media/images/slide-21-94f0ea8e5cdb4271391041c2caf0e3c9.jpg";